import type { ArticleCard as ArticleCardType } from 'types/capi/shared';

import ArticleCard from '~/components/ArticleCard';

import { MODULE_TYPES } from './index';

const PAGE_POSITION = 'Homepage Article Headlines';

type Props = { items: ArticleCardType[]; modulePosition: number };

export default function Headlines({ items, modulePosition }: Props) {
  const [hero, sideA, sideB] = items;
  if (!hero || !sideA || !sideB) return null;

  const shared = {
    modulePosition,
    moduleType: MODULE_TYPES.headlines,
    name: 'LATEST_NEWS' as const,
    pagePosition: PAGE_POSITION
  } as const;

  return (
    <div className="w-full bg-grey-tile">
      <div className="content-width py-10 md:py-20">
        <div className="carousel-width no-scrollbar flex items-center gap-2 md:gap-6">
          <ArticleCard
            {...shared}
            className="order-1 shrink-0 max-md:w-[285px] md:order-2 md:flex-1 md:self-stretch"
            item={hero}
            position={1}
            variant="4/5-text-over"
          />
          <ArticleCard
            {...shared}
            className="order-2 hidden shrink-0 max-md:w-[285px] md:order-1 md:flex-1 desktop:block"
            item={sideA}
            position={2}
            variant="16/9-text-under"
          />
          <ArticleCard
            {...shared}
            className="order-3 hidden shrink-0 max-md:w-[285px] md:order-3 md:flex-1 desktop:block"
            item={sideB}
            position={3}
            variant="16/9-text-under"
          />

          {/* Mobile variants */}
          <ArticleCard
            {...shared}
            className="order-2 shrink-0 max-md:w-[285px] md:order-1 md:flex-1 desktop:hidden"
            item={sideA}
            position={2}
            variant="4/5-text-over"
          />
          <ArticleCard
            {...shared}
            className="order-3 shrink-0 max-md:w-[285px] md:order-3 md:flex-1 desktop:hidden"
            item={sideB}
            position={3}
            variant="4/5-text-over"
          />
        </div>
      </div>
    </div>
  );
}
